import React, { useState } from "react";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";

function MobileDropdown({ currentCategory, categories, setCategoryId, navigate }) {
   const [isDropDownOpen, setisDropDownOpen] = useState(false);

   return (
      <div className="blogCategory__MobileDropDown__container">
         <div
            className="blogCategory__MobileDropDown__container__title"
            onClick={() => setisDropDownOpen(!isDropDownOpen)}
         >
            <p>Topics</p>
            {isDropDownOpen ? (
               <AiOutlineUp
                  style={{
                     strokeWidth: " 2px",
                     stroke: "#000",
                     width: "16px",
                     height: "12px",
                     marginTop: "2px",
                  }}
               />
            ) : (
               <AiOutlineDown
                  style={{
                     strokeWidth: "2px",
                     stroke: "#000",
                     width: "16px",
                     height: "12px",
                     marginTop: "2px",
                  }}
               />
            )}
         </div>
         {isDropDownOpen && (
            <div className="blogCategory__MobileDropDown__container__categories">
               {Object.entries(categories)?.map(([key, value]) => {
                  return (
                     <CategoryCard
                        data={value}
                        activeCategory={currentCategory}
                        setCategoryId={setCategoryId}
                        navigate={navigate}
                     />
                  );
               })}
            </div>
         )}
      </div>
   );
}

function CategoryCard({ data, activeCategory, setCategoryId, navigate }) {
   return navigate ? (
      <a href={`/company/blogs/category/${data?._id}`}>
         <div className={"blogCategory__button"}>
            <img src={`${process.env.REACT_APP_FILE_URL}/${data?.logo}`} alt="" className="logo" />
            <p className="text">{data?.title}</p>
         </div>
      </a>
   ) : (
      <div
         className={`blogCategory__button ${
            activeCategory?._id && data?._id === activeCategory?._id && "active"
         }`}
         onClick={() => {
            window.history.pushState(null, "", `/company/blogs/category/${data?._id}`);
            setCategoryId && setCategoryId(data?._id);
         }}
      >
         <img src={`${process.env.REACT_APP_FILE_URL}/${data?.logo}`} alt="" className="logo" />
         <p className="text">{data?.title}</p>
      </div>
   );
}

export default MobileDropdown;
